import { isLandscape } from '../../../ui/cardOrientation';

/**
 * Props für `ui/CardImage` aus einer Karteninstanz des Playtest-Zustands: Bild, Rückseite, Name,
 * die vom Server bestimmte sichtbare Seite (`transformedFace` 1 = Rückseite) und die
 * Bild-Ausrichtung (`imageOrientation`; fehlt sie — maskierte Karten, ältere Sessions — gilt
 * hochkant). Ob die Ausrichtung wirkt, entscheidet der Konsument über `landscape`; auf der
 * Brett-Oberfläche bleibt sie aus, nur die Großansicht zeigt quer.
 * Eine Flip-Karte (Kamigawa) hat keine Rückseite: `backSrc` bleibt leer, bei `transformedFace` 1
 * ist `face` trotzdem 'back', und `CardImage` zeigt ohne `backSrc` das Vorderseitenbild. Ein
 * `backSrc` gleich `src` ließe `hasBack` überall Umdreh-Knöpfe aktivieren.
 */
export function cardImageProps(card) {
  const data = card?.scryfallData || {};
  return {
    src: data.imageUrl || data.image_uris?.normal || '',
    backSrc: data.imageUrlBack || '',
    alt: data.name || '',
    face: card?.transformedFace === 1 ? 'back' : 'front',
    orientation: data.imageOrientation,
  };
}

export const otherFace = (face) => (face === 'back' ? 'front' : 'back');

/**
 * Lage der sichtbaren Seite in Grad: 90 für eine quer liegende Seite, 180 für die umgedrehte Hälfte
 * einer Flip-Karte, sonst 0. Verdeckt (faceDown) gibt es keine sichtbare Seite: 0.
 */
export function faceRotation(card) {
  if (card.faceDown) return 0;
  const orientation = card.scryfallData?.imageOrientation;
  const turned = card.transformedFace === 1;
  // Querlage und Flip sind reine Anzeige um den Kartenmittelpunkt; der Server kennt nur die Tapp-Drehung (Spec 2026-11-01-playtest-rueckseiten-loyalitaet-verteidigung-design.md §7).
  if (orientation === 'flip') return turned ? 180 : 0;
  return isLandscape(orientation, turned ? 'back' : 'front') ? 90 : 0;
}

/** Drehung des Kartenkörpers auf dem Brett in Grad, ohne Betrachter-Drehung: Lage der Seite (`faceRotation`) plus 90 getappt. */
export function boardCardRotation(card) {
  return faceRotation(card) + (card.tapped ? 90 : 0);
}
